import { render, staticRenderFns } from "./sign.vue?vue&type=template&id=38631931&scoped=true"
import script from "./sign.vue?vue&type=script&lang=ts"
export * from "./sign.vue?vue&type=script&lang=ts"
import style0 from "./sign.vue?vue&type=style&index=0&id=38631931&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38631931",
  null
  
)

export default component.exports